<template>
    <div>
        <common-page-header
            :heading="$t('pages.billing.billing.table.payment_history')"
            size="page-plain-header"
            contentSpacing="medium"
        ></common-page-header>
        <table class="tracking-listing">
            <thead>
                <tr>
                    <th>{{ $t('pages.billing.billing.table.period') }}</th>
                    <th v-if="!isTablet">{{ $t('pages.billing.billing.table.fee') }}</th>
                    <th v-if="!isTablet">{{ $t('pages.billing.billing.table.concierge') }}</th>
                    <th v-if="!isTablet">{{ $t('pages.billing.billing.table.total') }}</th>
                    <th v-if="!isTablet">{{ $t('pages.billing.billing.table.paid') }}</th>
                    <th>{{ $t('pages.billing.billing.table.invoice') }}</th>
                    <th></th>
                </tr>
            </thead>

            <tbody v-if="invoiceData.length">
                <tr v-for="(invoice, index) in invoiceData" :key="index">
                    <td>
                        <p class="tracking-listing__date">
                            From:
                            <b>{{ formatDate(invoice.fromDate) }}</b>
                        </p>
                        <p class="tracking-listing__date">
                            To:
                            <b>{{ formatDate(invoice.toDate) }}</b>
                        </p>
                    </td>
                    <td v-if="!isTablet">
                        ${{ invoice.totalPrice / 100 - invoice.prices.per_referral * invoice.numberOfReferrals }}
                    </td>
                    <td v-if="!isTablet">
                        <p>${{ invoice.prices.per_referral * invoice.numberOfReferrals }}</p>
                        <p>{{ invoice.numberOfReferrals }} {{ $t('pages.billing.billing.table.appointments') }}</p>
                    </td>
                    <td v-if="!isTablet">
                        <p>
                            <b>${{ invoice.totalPrice / 100 }}</b>
                        </p>
                    </td>
                    <td v-if="!isTablet">
                        <p>{{ formatDate(invoice.createdDate) }}</p>
                    </td>
                    <td>
                        <common-button
                            :label="$t('pages.billing.billing.table.invoice')"
                            :isSubmittable="false"
                            size="small-font"
                            type="secondary"
                            @click="openInvoiceModal(invoice)"
                        ></common-button>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>{{ $t('pages.billing.billing.table.no_history') }}</tr>
            </tbody>
        </table>
        <invoice-modal v-if="isInvoiceModalOpen" :modalData="modalData" @close="isInvoiceModalOpen = false"></invoice-modal>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import InvoiceModal from 'components/page-elements/practice/billing/InvoiceModal'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [ScreenSizeDetectionMixin],
        components: { InvoiceModal },

        props: {
            invoiceData: { type: Array, required: false, default: () => [] },
        },

        data() {
            return {
                isInvoiceModalOpen: false,
                modalData: {},
            }
        },

        methods: {
            formatDate(date) {
                return dayjs(date).format('MMMM D, YYYY')
            },

            openInvoiceModal(invoice) {
                this.modalData = invoice
                this.isInvoiceModalOpen = true
            },
        },
    }
</script>
